// Initialise the table of contents when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', function () {
  // Get references to the main article content and table of contents container
  const articleContent = document.querySelector('.article-template__content');
  const contentsTable = document.getElementById('contentsTable');

  if (articleContent && contentsTable) {
    // Find all content sections that may contain headings
    const contentSections = document.querySelectorAll('.rich-text__blocks, .article-template__content');
    let headings = [];

    // Collect all h2 and h3 headings from content sections in document order
    contentSections.forEach((section) => {
      if (section.matches('.rich-text__blocks')) {
        const sectionHeadings = section.querySelectorAll('h2, h3');
        headings = [...headings, ...Array.from(sectionHeadings)];
      } else if (section.matches('.article-template__content')) {
        const articleHeadings = section.querySelectorAll('h2, h3');
        headings = [...headings, ...Array.from(articleHeadings)];
      }
    });

    // Track current h2 section for nesting h3s
    let currentH2SubList = null;
    // Counters for heading numbers
    let h2Counter = 0;
    let h3Counter = 0;

    // Process each heading to create table of contents entries
    headings.forEach((heading, index) => {
      // Skip empty headings
      if (!heading.textContent.trim()) return;

      // Generate an ID if heading doesn't have one
      if (!heading.id) {
        heading.id = `section-${index}`;
      }

      // Create link element that points to the heading
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.classList.add('contents-table__link');

      // Create spans for styling and structure
      const textSpan = document.createElement('span');
      textSpan.classList.add('contents-table__text');

      const numberSpan = document.createElement('span');
      numberSpan.classList.add('contents-table__number');

      const contentSpan = document.createElement('span');
      contentSpan.classList.add('contents-table__content');

      // Add arrow icon for visual indication
      const arrowSpan = document.createElement('span');
      arrowSpan.classList.add('contents-table__arrow');
      arrowSpan.innerHTML =
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.1673 10.8333L10.0007 15M10.0007 15L5.83398 10.8333M10.0007 15L10.0007 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      // Assemble the link structure
      textSpan.appendChild(numberSpan);
      textSpan.appendChild(contentSpan);
      link.appendChild(textSpan);
      link.appendChild(arrowSpan);

      // Add smooth scrolling behavior with offset
      link.addEventListener('click', (event) => {
        event.preventDefault();
        // Offset to leave space above the heading
        const yOffset = -50;
        const element = document.getElementById(heading.id);
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });

      // Handle h2 headings - create new section in table of contents
      if (heading.tagName.toLowerCase() === 'h2') {
        h2Counter++;
        // Reset h3 counter for new section
        h3Counter = 0;
        numberSpan.textContent = `${h2Counter}. `;
        contentSpan.textContent = heading.textContent;

        const listItem = document.createElement('li');
        listItem.classList.add('contents-table__h2');
        listItem.appendChild(link);

        // Create sublist for potential h3 headings
        const subList = document.createElement('ul');
        subList.classList.add('contents-table__sub-list');
        listItem.appendChild(subList);

        contentsTable.appendChild(listItem);

        // Update tracking variable for h3 nesting
        currentH2SubList = subList;
      }
      // Handle h3 headings - add to current h2 section
      else if (heading.tagName.toLowerCase() === 'h3' && currentH2SubList) {
        h3Counter++;
        numberSpan.textContent = `${h2Counter}.${h3Counter} `;
        contentSpan.textContent = heading.textContent;

        const listItem = document.createElement('li');
        listItem.classList.add('contents-table__h3');
        listItem.appendChild(link);
        currentH2SubList.appendChild(listItem);
      }
    });
  }
});
